<template>
       <div class="main-footer">
        <span>&copy; 2023. <a href="#">UltraTech Cement Limited</a>. All Rights Reserved.</span>
        <span>Created by: <a href="" target="_blank">AKXA</a></span>
      </div><!-- main-footer -->
</template>